/**
 * Utility functions for user-related operations
 */

/**
 * Get user initials from full name
 * @param {string} name - User's full name
 * @returns {string} User initials (up to 2 characters)
 */
export const getUserInitials = (name) => {
    if (!name || typeof name !== 'string') {
        return 'U';
    }

    const nameParts = name.trim().split(/\s+/);
    
    if (nameParts.length === 1) {
        // Single name - return first 2 characters
        return nameParts[0].substring(0, 2).toUpperCase();
    }
    
    // Multiple names - return first letter of first and last name
    const firstInitial = nameParts[0][0];
    const lastInitial = nameParts[nameParts.length - 1][0];
    
    return `${firstInitial}${lastInitial}`.toUpperCase();
};

/**
 * Get family initials from family name
 * @param {string} name - Family name
 * @returns {string} Family initials (up to 2 characters)
 */
export const getFamilyInitials = (name) => {
    if (!name || typeof name !== 'string') {
        return 'F';
    }

    const nameParts = name.trim().split(/\s+/);
    
    if (nameParts.length === 1) {
        // Single name - return first 2 characters
        return nameParts[0].substring(0, 2).toUpperCase();
    }
    
    // Multiple names - return first letter of first and last name
    const firstInitial = nameParts[0][0];
    const lastInitial = nameParts[nameParts.length - 1][0];
    
    return `${firstInitial}${lastInitial}`.toUpperCase();
};
